<template>
    <!-- Sticky Navigation -->
    <nav class="nav-blur shadow-sm fixed w-full z-10 top-0 ">
        <div class="container mx-auto pl-6 pr-4 lg:px-0 lg:pr-6 py-4 flex justify-between items-center">
            <div class="flex items-center space-x-8">
                <ApplicationLogo :color="isPastStats ? 'gray' : 'white'">
                </ApplicationLogo>
                <div class="hidden md:flex space-x-8 text-sm mt-1">
                    <button @click="scrollToSection('examples')" :class="[isPastStats ? 'text-gray-700' : 'text-gray-300', 'hover:text-blue-700 hover:border-b-2 hover:border-blue-700 font-medium pb-1 transition-colors duration-500']">
                        Examples
                    </button>
                    <button @click="scrollToSection('pricing')" :class="[isPastStats ? 'text-gray-700' : 'text-gray-300', 'hover:text-blue-700 hover:border-b-2 hover:border-blue-700 font-medium pb-1 transition-colors duration-500']">
                        Pricing
                    </button>
                </div>
            </div>
            <div class="flex items-center space-x-4">
                <ShinyButton v-if="$page.props.auth.user" :href="route('headshots.index')">
                    Open
                </ShinyButton>
                <ShinyButton v-else :href="route('login')">
                    Try now
                </ShinyButton>
                
                
                <!-- Mobile menu button -->
                <button @click="toggleMobileMenu" :class="['md:hidden', isPastStats ? 'text-gray-700' : 'text-white', 'hover:text-blue-300 transition-colors duration-200']">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                        <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Mobile menu -->
        <div
            v-if="mobileMenuOpen"
            :class="[
                'md:hidden backdrop-blur-lg',
                isPastStats ? 'bg-white bg-opacity-35' : 'bg-black bg-opacity-15'
            ]"
        >
            <div class="px-6 py-4 space-y-4">
                <button
                    @click="scrollToSection('examples'); mobileMenuOpen = false;"
                    :class="[
                        'block w-full text-left hover:text-blue-300 transition-colors duration-200 py-2',
                        isPastStats ? 'text-gray-700' : 'text-white'
                    ]"
                >
                    Examples
                </button>
                <button
                    @click="scrollToSection('pricing'); mobileMenuOpen = false;"
                    :class="[
                        'block w-full text-left hover:text-blue-300 transition-colors duration-200 py-2',
                        isPastStats ? 'text-gray-700' : 'text-white'
                    ]"
                >
                    Pricing
                </button>
                <Link
                    :href="route('login')"
                    @click="mobileMenuOpen = false;"
                    :class="[
                        'block w-full text-left hover:text-blue-300 transition-colors duration-200 py-2',
                        isPastStats ? 'text-gray-700' : 'text-white'
                    ]"
                >
                    Sign In
                </Link>

            </div>
        </div>
    </nav>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import ShinyButton from '@/Components/ShinyButton.vue';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';

export default {
    props: {
        canLogin: {
            type: Boolean,
            required: true
        },
        canRegister: {
            type: Boolean,
            required: true
        },

    },
    components: {
        Head,
        Link,
        ShinyButton,
        ApplicationLogo
    },
    data() {
        return {
            mobileMenuOpen: false,
            isPastStats: false
        }
    },
    mounted() {
        this.updatePastStats();
        window.addEventListener('scroll', this.updatePastStats, { passive: true });
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.updatePastStats);
    },
    methods: {
        scrollToSection(sectionId) {
            const element = document.getElementById(sectionId);
            if (element) {
                const navHeight = 80; // Approximate height of the fixed navigation
                const elementPosition = element.offsetTop - navHeight;
                window.scrollTo({
                    top: elementPosition,
                    behavior: 'smooth'
                });
            }
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        updatePastStats() {
            const stats = document.getElementById('stats');
            if (!stats) {
                this.isPastStats = false;
                return;
            }
            const rect = stats.getBoundingClientRect();
            // Switch after stats row passes under the nav
            this.isPastStats = rect.bottom <= 72; // ~nav height
        }
    }
}
</script>

<style>
.gradient-text {
    background: linear-gradient(90deg, #0e4aba, #6e91c2);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.scroll-container {
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}

.scroll-container::-webkit-scrollbar {
    display: none;
}

.main-heading {
    color: #f0f4ff;
    /* Closer to white with a tinge of dark navy */
}

.nav-blur {
    backdrop-filter: blur(10px);
}

/* Subtle text outlines to enhance contrast on mixed backgrounds */
/* outline utilities removed */

@supports ((-webkit-backdrop-filter: initial) or (backdrop-filter: initial)) {
    #ac-localnav.ac-ln-sticking .ac-ln-background {
        -webkit-backdrop-filter: saturate(180%) blur(20px);
        backdrop-filter: saturate(180%) blur(20px);
    }
}

</style>